import { render, staticRenderFns } from "./ReportSMSSummaries.vue?vue&type=template&id=70a21fa5&"
import script from "./ReportSMSSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportSMSSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports